import { useAuthStore } from '@/stores/authStore';

/**
 * Whether the current trader may open the RFQ desk (/rfq).
 * Resolved relay-side (GET /api/trader/me → `rfqAccess`, from
 * traderRules.rfqEnabled — fail-closed) and threaded onto the session by
 * refreshMe(). Defaults to false so the surface never leaks before access
 * lands. The relay enforces the same flag on /api/rfq/* — display gating only.
 */
export function useRfqAccess(): boolean {
  return useAuthStore((s) => s.user?.rfqAccess ?? false);
}
